export type PosicaoMia = { left: number; top: number };

const COOKIE = 'momy.mia.posicao';
const COOKIE_ANTIGO = 'momy.mia.canto';
const MAX_AGE_SEGUNDOS = 180 * 24 * 60 * 60;
const ARRASTE_MINIMO_PX = 6;
const MARGEM_PX = 8;

export function lerPosicaoMia(): PosicaoMia | null {
  const valor = lerCookie(COOKIE);
  if (!valor) return null;
  const [esquerda, topo] = valor.split(',');
  const left = Number(esquerda);
  const top = Number(topo);
  if (!Number.isFinite(left) || !Number.isFinite(top)) return null;
  return { left, top };
}

export function gravarPosicaoMia(posicao: PosicaoMia): void {
  if (typeof document === 'undefined') return;
  document.cookie = `${COOKIE_ANTIGO}=; path=/; max-age=0`;
  const valor = `${Math.round(posicao.left)},${Math.round(posicao.top)}`;
  document.cookie = `${COOKIE}=${encodeURIComponent(valor)}; path=/; max-age=${MAX_AGE_SEGUNDOS}; SameSite=Lax`;
}

export function limitarPosicao(
  left: number,
  top: number,
  larguraJanela: number,
  alturaJanela: number,
  larguraBotao: number,
  alturaBotao: number,
): PosicaoMia {
  const maxLeft = Math.max(MARGEM_PX, larguraJanela - larguraBotao - MARGEM_PX);
  const maxTop = Math.max(MARGEM_PX, alturaJanela - alturaBotao - MARGEM_PX);
  return {
    left: Math.min(maxLeft, Math.max(MARGEM_PX, left)),
    top: Math.min(maxTop, Math.max(MARGEM_PX, top)),
  };
}

export function arrastePassouDoClique(dx: number, dy: number): boolean {
  return Math.hypot(dx, dy) >= ARRASTE_MINIMO_PX;
}

function lerCookie(nome: string): string | null {
  if (typeof document === 'undefined') return null;
  for (const parte of document.cookie.split(';')) {
    const trimmed = parte.trim();
    const eq = trimmed.indexOf('=');
    if (eq < 0 || trimmed.slice(0, eq) !== nome) continue;
    try {
      return decodeURIComponent(trimmed.slice(eq + 1));
    } catch {
      return null;
    }
  }
  return null;
}
